<template>
  <div class="password_container">
    <!-- <div class="goback"
         @click="goBack">返回</div> -->
    <div class="change_password">
      <div class="title">修改密码</div>
      <div class="form">
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-width="44.5%"
          class="demo-ruleForm"
        >
          <el-form-item label="旧密码" prop="oldpass">
            <el-input
              type="password"
              placeholder="请输入旧密码"
              v-model="ruleForm.oldpass"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="pass">
            <el-input
              type="password"
              placeholder="请输入新密码"
              v-model="ruleForm.pass"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码确认" prop="checkPass">
            <el-input
              type="password"
              placeholder="请再次输入新密码"
              v-model="ruleForm.checkPass"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="button_style">
          <el-button class="publicBtn" @click="resetForm('ruleForm')"
            >取消</el-button
          >
          <el-button
            class="publicBtn"
            type="primary"
            @click="submitForm('ruleForm')"
            >确认</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { editPsd } from "common/js/api";
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入旧密码"));
      } else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass3 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        oldpass: "",
        pass: "",
        checkPass: "",
      },
      rules: {
        oldpass: [{ validator: validatePass, trigger: "blur" }],
        pass: [
          {
            pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/g,
            message: "密码必须包含字母和数字，且长度不小于8位",
            trigger: "blur",
          },
        ],
        checkPass: [{ validator: validatePass3, trigger: "blur" }],
      },
      userCode: "",
    };
  },

  created() {
    this.userCode = this.Cookies.get("identifyCode");
  },

  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    async submit() {
      const params = {
        identifyCode: this.userCode,
        newPwd: this.$md5(this.ruleForm.pass),
        oldPwd: this.$md5(this.ruleForm.oldpass),
      };

      const { message } = await editPsd(params);
      if (message.includes("成功")) {
        this.$message({
          message: "修改成功!",
          type: "success",
        });
        setTimeout(() => {
          this.loginOut();
        }, 500);
      } else {
        this.$message({
          message,
          type: "warning",
        });
      }
    },

    loginOut() {
      const code = this.Cookies.get("identifyCode");
      let loginPath = "/Login";
      if (code && code.slice(0, 2) == "WR") loginPath = "/ReportLogin";

      this.Cookies.remove("legalName");
      this.Cookies.remove("institutionName");
      this.Cookies.remove("identifyCode");
      this.Cookies.remove("riskToken");
      this.$router.push(loginPath);
    },

    resetForm(formName) {
      console.log("this", this);
      const code = this.Cookies.get("identifyCode");
      if (code && code.slice(0, 2) == "WR") {
        this.$router.push("/ReportPlatform/ReportList");
        this.$refs[formName].resetFields();
      } else {
        this.$router.push("/UC/User");
        this.$refs[formName].resetFields();
      }
    },
    // goBack () {
    //   this.$router.go(-1);
    // }
  },
};
</script>
<style scoped lang="scss">
.goback {
  position: absolute;
  cursor: pointer;
  width: 100px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  right: 20px;
  top: 0;
  border: 1px solid #dddddd;
  border-radius: 2px;
  font-size: 12px;
  color: #6c7885;
}
.form {
  width: 100%;
  margin: 0 auto;
  padding-top: 30px;
  ::v-deep  .el-form-item {
    margin-bottom: 22px !important;
  }
  ::v-deep .el-form-item__label {
    font-size: 16px;
    font-family: Alibaba;
    text-align: right;
    color: #5f5f5f;
  }
  .el-input {
    width: 300px;
    height: 38px;
  }
}

.password_container {
  position: relative;
  height: 100%;
  padding-top: 126px;
  /* margin-top: 126px; */
}
.change_password {
  width: 100;
  margin: auto;
}
.title {
  font-size: 24px;
  font-family: AlibabaM;
  color: #191818;
  line-height: 33px;
  text-align: center;
  margin-bottom: 126px 0 40px;
}
.button_style {
  text-align: center;
  margin-top: 44px;
}
</style>
